import style from "./CompanyDynamics.module.css";
import companytitle1 from "../../assets/images/companytitle1.jpg";
import { Link } from "react-router-dom";
import request from "../../common/request";

import { useEffect, useState, useRef } from "react";

const months = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export default function Main() {
  const [list, setList] = useState([]);
  useEffect(() => {
    request.getArticleList(1, 1).then(function (result) {
      console.log(result);
      setList(result.data.data.data.slice(0, 3));
    });
  }, []);

  return (
    <>
      <div className={style.mainbox}>
        <div className={style.header}>
          <img src={companytitle1} style={{ width: "200px" }} />
          <Link to="/company">了解更多 → </Link>
        </div>
        <div className={style.articles}>
          {list.map((item, index) => (
            <div key={index}>
              <Link to={`/article/` + item.id}>
                <div className={style.aleft}>
                  <h5>{item.created_at.split(" ")[0].split("-")[2]}</h5>
                  <label>
                    {months[item.created_at.split(" ")[0].split("-")[1]]}
                  </label>
                </div>
                <div className={style.aright}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
